import { ChangeDetectionStrategy, Component, input, model } from '@angular/core'
import { FormValueControl } from '@angular/forms/signals'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

/**
 * Auswahl **einer** Datei.
 *
 * **`FormValueControl`**: der Wert liegt in einem `model()`. Damit laesst sich die Komponente an
 * einen Signal-Forms-Feldbaum binden (`[formField]="fg.datei"`) **und** ohne jedes Formular
 * verwenden (`[(value)]="meinSignal"`). Wer sie aus einer verbliebenen Reactive-`FormGroup`
 * heraus binden muss, wickelt das Control mit `compatForm(...)` ein — siehe den
 * PHM-Genehmigungs-Dialog der Leistungserbringer-App.
 */
@Component({
  selector: 'lib-file-select',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './file-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './file-select.component.scss',
})
export class FileSelectComponent implements FormValueControl<File | null> {
  readonly value = model<File | null>(null)

  /** Von Signal Forms gespiegelt, wenn eine `disabled(...)`-Regel auf dem Feld liegt. */
  readonly disabled = input(false)

  readonly label = input('Datei auswählen')
  readonly icon = input('file_open')

  readonly fileType = input('*')
  readonly loading = input(false)

  /**
   * Zeigt den Namen der gewaehlten Datei bzw. „Keine Datei ausgewaehlt" neben dem Knopf.
   *
   * Default `true` — in Dialogen, wo man erst waehlt und dann bestaetigt, ist der Text die
   * Rueckmeldung, dass die Auswahl angekommen ist. **Aus** gehoert er dort, wo der Upload sofort
   * beim Waehlen laeuft: dann steht dauerhaft „Keine Datei ausgewaehlt" neben einer Datei, die
   * laengst hochgeladen ist (real missverstanden in der Datei-Liste des Leistungserbringer-
   * Formulars: „man sieht nicht was hochgeladen ist und was nicht").
   */
  readonly showFileName = input(true)

  setFile(file?: File) {
    this.value.set(file ?? null)
  }
}
